// NATIVE 
import { useCallback, useEffect, useRef, useState } from 'react';


// INSTALLED 
import Webcam from "react-webcam";
import { useFormikContext } from 'formik';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Card, Divider, Grid, TextField, Typography } from '@mui/material';


// CUSTOM 
import { SnackAlert } from '../../SnackAlert';
import InputField from '../../formFields/InputField';
import InputNumeric from '../../formFields/InputNumeric';
import { uploadFileImageFromCamera, uploadPdfStore } from '../../../store/uploaders';
import TextAreaField from '../../formFields/TextAreaField';
import CheckboxField from '../../formFields/checkBoxField';
import { IDatosBasicos } from '../../../commons/interfaces';
import DatePickerField from '../../formFields/datePickerField';
import AutocompleteField from '../../formFields/autocompleteField';
import { UploadButtonField } from '../../formFields/uploadButtonField';
import { LinearProgressWithLabel } from '../../LinearProgressWithLabel';




export const InformacionBasica = (props:any) => {


    // USE DISPATCH 
    const dispatch = useDispatch();


    // USE FORMIK CONTEXT 
    const formikProps:any = useFormikContext();


    // REDUX
    const  {  countries_list, sites_list }:IDatosBasicos  = useSelector( (state:any) => state.company );
    const  {  company, company_select }:any  = useSelector( (state:any) => state.company );
    
    const  {  sucursales_list_select }:any  = useSelector( (state:any) => state.sucursales );
    
    const  { cargos_list, cargos_select }  = useSelector( (state:any) => state.cargos );
    const  { type_documents_list, type_documents_list_select } = useSelector( (state:any) => state.tipodocumento );

    const   orchata  = useSelector( (state:any) => state );
    
    const { departaments_list }:any = useSelector( (state:any) => state.departaments );
    const { municipaly_list }:any = useSelector( (state:any) => state.municipalies );

   
    const [typeDocument, setTypeDocument] = useState([]);

    const [countries,      setCountries]     = useState([]);
    const [departaments,   setDepartaments]  = useState([]);
    const [municipalies,   setMunicipalies]  = useState([]);
    const [cargos, setCargos] = useState([]);


    const [percentage_upload_cc, setPercentageUploadCc]   = useState(0);
    const [percentage_upload_cv, setPercentageUploadCv]   = useState(0);
    

     const [textAlertSnack, setTextAlertSnack] = useState('');
    const [severity, setSeverity] = useState('success');


    const [showCamera, setShowCamera] = useState(false);
    const [imgSrc, setImgSrc] = useState(null);
    

    // COMPAÑIA 
    const [company_formated, setCompanyFormated] = useState([]);


    // ALERTS PARA CONFIGURACION SUBIR IMAGEN 
    const [alert_snack, setAlertSnack] = useState(false);
    const [alert_snack_company, setAlertSnackCompany] = useState(false);
    const [alert_snack_cargos, setAlertSnackCargos] = useState(false);


    const [percentage_upload_cedula, setPercentageUploadRut] = useState(0);



    const { formField: {
        // DATOS CLIENTE 
        document_type,
        expedition_place,
        name,
        document_number,
        last_name,
        date_of_birth,
        gender,
        civil_status,
        landline,
        cell_phone,
        whatsapp,
        rh,
        dominance,
        allergies,
        cedula,
        housing_type,
        neighborhood,
        stratum,
        cost_center,
        compani,
        work_headquarters,
        cargo,
        cv,
        scholarship,
        institution,
        degree,
        address,
        email
      }
    } = props;



  
    useEffect(() => {

      if ( Object.keys(company).length > 0 && company.constructor === Object ) {
           
           const dataCompany:any = [{
               label: company.tradename,
               value: company.id

          }];

           setCompanyFormated(dataCompany);


           const dataCompanyDefault = {
              label: company.tradename,
              value: company.id
           }

           formikProps.setFieldValue('compani', dataCompanyDefault );
           
      }
      
    }, [company]);
    
   

    useEffect(() => {
        getDataInputesForm();
     }, []);
 
 
     useEffect(() => {
       setDepartaments(departaments_list);
     }, [departaments_list]);
 
     useEffect(() => {
       setMunicipalies(municipaly_list);
     }, [municipaly_list]);




    //  CARGOS 
     useEffect(() => {

      if ( cargos_list.length > 0 ) {

        const cargosList = cargos_list.map( (item:any) => {
              return {
                label: item.name, 
                value: item.id
              };
        });

        setCargos(cargosList);

      }
      

     }, [cargos_list]);
     


     const getDataInputesForm = async () => {

        // console.log('sddddd')
        // const response = await dispatch( getFormsDataS() );

        
        // setCountries([]);
        // setDepartaments([]);
        // setMunicipalies([]);
    }


    
    const genderList =  [
      { label: 'Masculino', value: 'masculino'},
      { label: 'Femenino', value: 'Femenino'},
      { label: 'Otro', value: 'otro'}
    ];


    const maritalStatus =  [
      { label: 'Soltero', value: 'soltero'},
      { label: 'Casado', value: 'casado'},
      { label: 'Union Libre', value: 'unionlibre'},
      { label: 'Viudo', value: 'viudo'},
      { label: 'Separado', value: 'separado'}
    ];
    

    
    const bloodType =  [
      { label: 'AB+', value: 'AB+'},
      { label: 'AB-', value: 'AB-'},
      { label: 'A+', value: 'A+'},
      { label: 'A-', value: 'A-'},
      { label: 'B+', value: 'B+'},
      { label: 'B-', value: 'B-'},
      { label: 'O+', value: 'O+'},
      { label: 'O-', value: 'O-'}
    ];


    const domiNacion =  [
      { label: 'zurdo', value: 'zurdo'},
      { label: 'diestro', value: 'diestro'},
      { label: 'ambidiestro', value: 'ambidiestro'}
    ];

    
    const typeOfHousing =  [
      { label: 'propia', value: 'propia'},
      { label: 'alquiler', value: 'alquiler'},
      { label: 'familiar', value: 'familiar'},
      { label: 'ninguno', value: 'ninguno'},
    ];


    const costCenter =  [
      { label: 'administrativo', value: 'administrativo'},
      { label: 'mano de obra directa', value: 'mano_de_obra_directa'},
      { label: 'mano de obra indirecta', value: 'mano_de_obra_indirecta'},
      { label: 'operativo', value: 'operativo'},
      { label: 'ventas', value: 'ventas'},
    ];


    
    const escolaridadList =  [
      { label: 'primaria', value: 'primaria'},
      { label: 'bachillerato', value: 'bachillerato'},
      { label: 'tecnico', value: 'tecnico'},
      { label: 'tecnologo', value: 'tecnologo'},
      { label: 'postgrado', value: 'postgrado'},
    ];


    const uploadCedula = async({ target }:any) => {
    
      formikProps.setFieldValue('cedula', target.files[0]);
      const { ok, data } = await dispatch( uploadPdfStore( 'cedula-empleado', target.files[0], setPercentageUploadCc) );
      
      if (ok) {
        formikProps.setFieldValue('cedula_name_saved_name', data.pdfName);
      }

    }


  const uploadCV = async({ target }:any) => {
  
    formikProps.setFieldValue('cv', target.files[0]);
    const { ok, data } = await dispatch( uploadPdfStore( 'cv-empleado', target.files[0], setPercentageUploadCv) );
    
    if (ok) {
      formikProps.setFieldValue('cv_name_saved_name', data.pdfName);
    }

  }


  const uploadImagenCamera = async (imgSrc:any) => {

    // Convertir la imagen a un archivo Blob
    const blob = await fetch(imgSrc).then((res) => res.blob());

    // formikProps.setFieldValue('fileCajaCompensacion', target.files[0]);
    const response = await dispatch( uploadFileImageFromCamera( 'avatar-employee', blob, setPercentageUploadCc) );
    

    if (!response.ok) {

      setImgSrc(null);
      formikProps.setFieldValue('foto_name_saved', null);
      setSeverity('error')
      setTextAlertSnack(response.errors[0]);
      setAlertSnack(true);
      return false;
    }

    if (response.ok) {
      formikProps.setFieldValue('foto_name_saved', response.data.imgName);
    }
    
  }
  
  const openCamera = () => {

    setShowCamera(!showCamera)
    setImgSrc(null);
  }


  const newPhoto = () => {

    setShowCamera(false)
  }


  const webcamRef:any = useRef(null);

  const capture = useCallback(() => {
    const imageSrc = webcamRef.current.getScreenshot();
    setImgSrc(imageSrc);
    setShowCamera(false);
    uploadImagenCamera(imageSrc);
  }, [webcamRef]);




  const videoConstraints = {
    width: 320,
    height: 240,
    facingMode: "user"
  };



  useEffect(() => {

    ( company_select.length <= 0 ) ? setAlertSnackCompany(true) : setAlertSnackCompany(false);

  }, [company_select]);

  useEffect(() => {
    
    ( cargos_select.length <= 0 ) ? setAlertSnackCargos(true) : setAlertSnackCargos(false);

  }, [cargos_select]);
  

  

  return (
    <div>
 

        <SnackAlert open={alert_snack_cargos} autohidden={false} onclick={setAlertSnackCargos} text={'Aun no has creado los cargos'} severity={"warning"} />

        <SnackAlert open={alert_snack_company} autohidden={false} onclick={setAlertSnackCompany} text={'Aun no has creado la compañia'} severity={"warning"} />

        
        <SnackAlert open={alert_snack} onclick={setAlertSnack} text={textAlertSnack} severity={severity}/>
        



        {/* <SnackbarProvider maxSnack={3}>
          <SnackGroupAlerts message={'aaaaaaa'} variant={'warning'}/>
        </SnackbarProvider> */}

        <Grid container spacing={2}>

          
          <Grid item xs={3}>

          {imgSrc ? (
            <img src={imgSrc} alt="webcam" width={320} height={240} />
          ) : (
            <></>
          )}

          {
            showCamera && 
              <>
                <Webcam
                audio={false}
                height={240}
                ref={webcamRef}
                screenshotFormat="image/png"
                width={320}
                videoConstraints={videoConstraints}
              />
              
              </>
          }

            {imgSrc && (
              <Button
                sx={{ margin: 2 }}
                variant="contained"
                onClick={ openCamera }
                color="primary">
                Tomar nueva foto
              </Button>
            )}
            
       

            {(!showCamera && !imgSrc) && (
              <Button
                sx={{ margin: 2 }}
                variant="contained"
                onClick={ openCamera }
                color="primary">
                Encender Camara
              </Button>
            ) }

            {showCamera && (
              <Button
                sx={{ margin: 2 }}
                variant="contained"
                onClick={ capture }
                color="success">
                Tomar foto
              </Button>
            )}
            
          </Grid>
        
        </Grid>



        <Grid container spacing={2}>

            <Grid item xs={3}> 

              {
                  
                  ( type_documents_list_select && Object.keys(type_documents_list_select).length > 0 )
                      ?
                      <AutocompleteField 
                        options={type_documents_list_select}
                        name={document_type.name}
                        label={document_type.label}
                        element={document_type.name}
                      />
 
                      :
                      <InputField 
                       disabled
                       error
                       name={'N/A'}
                       label={'Debes crear los tipos de documentos*'}
                       variant="outlined" 
                       fullWidth
                      />
              }
                
            </Grid>
            <Grid item xs={3}>
              <InputNumeric 
                name={document_number.name}
                label={document_number.label}
                variant="outlined" 
                fullWidth
              />
            </Grid>
            <Grid item xs={3}>
              <InputField 
                name={expedition_place.name}
                label={expedition_place.label}
                variant="outlined" 
                fullWidth
              />
            </Grid>
            
            
            <Grid item xs={3}>
              <InputField 
                name={name.name}
                label={name.label}
                variant="outlined" 
                fullWidth
              />
            </Grid>

        </Grid>
        {/* END GRID  */}



        
        <Grid container spacing={2} style={{ marginTop: 15 }}>

            <Grid item xs={3}>
              <InputField 
                name={last_name.name}
                label={last_name.label}
                variant="outlined" 
                fullWidth
              />
            </Grid>
            <Grid item xs={3}>
              <DatePickerField label={date_of_birth.label} 
                                      name={date_of_birth.name}/>
            </Grid> 
            <Grid item xs={3}>
                <AutocompleteField 
                   options={genderList}
                   name={gender.name}
                   label={gender.label}
                   element={gender.name}
                />
            </Grid> 
            <Grid item xs={3}>
                <AutocompleteField 
                   options={maritalStatus}
                   name={civil_status.name}
                   label={civil_status.label}
                   element={civil_status.name}
                />
            </Grid>

        </Grid>
        {/* END GRID  */}





        <Grid container spacing={2} style={{ marginTop: 15 }}>
            <Grid item xs={3}>
              <InputNumeric 
                name={landline.name}
                label={landline.label}
                variant="outlined" 
                fullWidth
              />
            </Grid>
            <Grid item xs={3}>
              <InputNumeric 
                name={cell_phone.name}
                label={cell_phone.label}
                variant="outlined" 
                fullWidth
              />
            </Grid>
            <Grid item xs={3} >
                  <div style={{ display: 'flex', flexDirection: 'row', lineHeight: 0 }}>
                  <CheckboxField  name={whatsapp.name} label={whatsapp.label}/>
                  </div>
            </Grid>
            <Grid item xs={3}>
              <InputField 
                name={email.name}
                label={email.label}
                variant="outlined" 
                fullWidth
              />
            </Grid>

        </Grid>
        {/* END GRID  */}



        <Grid container spacing={2} style={{ marginTop: 15 }}>
            <Grid item xs={3}>
                <AutocompleteField 
                   options={bloodType}
                   name={rh.name}
                   label={rh.label}
                   element={rh.name}
                />
            </Grid> 
            <Grid item xs={3}>
                <AutocompleteField 
                   options={domiNacion}
                   name={dominance.name}
                   label={dominance.label}
                   element={dominance.name}
                />
            </Grid> 
            <Grid item xs={3}>
              <TextAreaField 
                name={allergies.name}
                label={allergies.label}
                variant="outlined" 
                fullWidth
                />
            </Grid>
            <Grid item xs={3}>
               <UploadButtonField accept={'application/pdf'} 
                                  name={cedula.name} 
                                  label={cedula.label} 
                                  text={'Cedula'} 
                                  onChange={uploadCedula}/>
                {
                  formikProps.values.cedula 
                       ?
                        <Card variant="elevation" sx={{  marginTop: 1.5, padding: 1, height: '70%',  }}>
                         <LinearProgressWithLabel percentage={percentage_upload_cc} label={formikProps.values.cedula.name} hasIcon={true} /> 
                        </Card>
                       :
                       ''
                }
            </Grid>

        </Grid>
        {/* END GRID  */}

        <Divider style={{ marginTop: 25 }}/>
        <Typography variant='h6' sx={{ fontWeight: 'bold', marginTop: 10 }}>Datos Domiciliarios</Typography>



        <Grid container spacing={2} style={{ marginTop: 15 }}>
            <Grid item xs={3}>
              <InputField 
                name={address.name}
                label={address.label}
                variant="outlined" 
                fullWidth
              />
            </Grid>
            
            <Grid item xs={3}>
                <InputField 
                  name={neighborhood.name}
                  label={neighborhood.label}
                  variant="outlined" 
                  fullWidth
                />
            </Grid>
            <Grid item xs={3}>
                <AutocompleteField 
                   options={typeOfHousing}
                   name={housing_type.name}
                   label={housing_type.label}
                   element={housing_type.name}
                />
            </Grid>
            <Grid item xs={2}>
                <InputNumeric 
                  name={stratum.name}
                  label={stratum.label}
                  variant="outlined" 
                  fullWidth
                />
            </Grid>
        </Grid>
         {/* END GRID  */}


        <Divider style={{ marginTop: 25 }}/>
        <Typography variant='h6' sx={{ fontWeight: 'bold', marginTop: 10 }}>Laboral</Typography>



        <Grid container spacing={2} style={{ marginTop: 15 }}>
            <Grid item xs={2}>
                <AutocompleteField 
                   options={costCenter}
                   name={cost_center.name}
                   label={cost_center.label}
                   element={cost_center.name}
                />
            </Grid>
            <Grid item xs={3}>
               {
                  
                 ( company_select && Object.keys(company_select).length > 0 )
                     ?
                     <AutocompleteField 
                        disabled
                        options={company_select}
                        name={compani.name}
                        label={compani.label}
                        element={compani.name}
                      />
                    
                      // <TextField
                      //   fullWidth
                      //   name={company.tradename}
                      //   label={compani.label}
                      //   defaultValue={company.tradename}
                      //   InputProps={{
                      //     readOnly: true,
                      //   }}
                      // />

                     :
                     <InputField 
                      disabled
                      error
                      name={'N/A'}
                      label={'Debes crear la compañia*'}
                      variant="outlined" 
                      fullWidth
                     />
               }
               
            </Grid>
            
            <Grid item xs={2}>  
                <AutocompleteField 
                   options={sucursales_list_select}
                   name={work_headquarters.name}
                   label={work_headquarters.label}
                   element={work_headquarters.name}
                />
            </Grid>
            <Grid item xs={3}>
                 
              {
                  
                  ( cargos_select && Object.keys(cargos_select).length > 0 )
                     ?
                      <AutocompleteField 
                        options={cargos_select}
                        name={cargo.name}
                        label={cargo.label}
                        element={cargo.name}
                      />
                     :
                     <InputField 
                      disabled
                      error
                      name={'N/A'}
                      label={'Debes crear los cargos*'}
                      variant="outlined" 
                      fullWidth
                     />
               }

                
            </Grid>
            <Grid item xs={2}>
               <UploadButtonField accept={'application/pdf'} 
                                  name={cv.name} 
                                  label={cv.label} 
                                  text={'Hoja de vida'} 
                                  onChange={uploadCV}/>
                {
                  formikProps.values.cv 
                       ?
                        <Card variant="elevation" sx={{  marginTop: 1.5, padding: 1, height: '70%',  }}>
                         <LinearProgressWithLabel percentage={percentage_upload_cv} label={formikProps.values.cv.name} hasIcon={true} /> 
                        </Card>
                       :
                       ''
                }
            </Grid>
        </Grid>
        {/* END GRID  */}



        <Divider style={{ marginTop: 25 }}/>
        <Typography variant='h6' sx={{ fontWeight: 'bold', marginTop: 10 }}>Academico</Typography>



        <Grid container spacing={2} style={{ marginTop: 15 }}>

            <Grid item xs={3}>
                <AutocompleteField 
                   options={escolaridadList}
                   name={scholarship.name}
                   label={scholarship.label}
                   element={scholarship.name}
                />
            </Grid>
            <Grid item xs={3}>
                <InputField 
                  name={institution.name}
                  label={institution.label}
                  variant="outlined" 
                  fullWidth
                />
            </Grid>
            <Grid item xs={3}>
                <InputField 
                  name={degree.name}
                  label={degree.label}
                  variant="outlined" 
                  fullWidth
                />
            </Grid>

        </Grid>

        {/* END GRID  */}





        

    </div>
  )
}
